import type { CourseModule } from "@/core/types";
import { lektionDesign } from "./lektion-01-design";
import { lektionFolienmaster } from "./lektion-02-folienmaster";
import { lektionDesignfarben } from "./lektion-03-designfarben";
import { lektionKopfFusszeileMaster } from "./lektion-04-kopf-fusszeile";

export const modulMaster: CourseModule = {
  id: "master",
  title: "Folienmaster und Design",
  summary:
    "Einmal einstellen statt vierzigmal nachziehen: Designs, der Folienmaster mit seinen " +
    "Layouts und der Unterschied zwischen Designfarben und festen Farbwerten.",
  level: "Grundlagen",
  lessons: [lektionDesign, lektionFolienmaster, lektionDesignfarben, lektionKopfFusszeileMaster],
};
